<!-- 运输方式 -->
<template>
<span>
    <el-dialog
        :title="msg('运输方式')"
        :visible.sync="visible"
        :close-on-click-modal="false"
        size="mini"
        width="400px"
    >
        <el-row>
            <el-col :gutter="10" :xs="24" :sm="24">
                <el-select v-model="transport" clearable :placeholder="msg('请选择运输方式')">
                    <el-option v-for="d in transportType" 
                        :label="d.label" :value="d.value" :key="d.value">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">{{msg('取消')}}</el-button>
            <el-button type="primary" @click="submit()">{{msg("提交")}}</el-button>
        </span>
    </el-dialog>
</span>    
</template>

<script>
export default {
    name: "TransportDialog",
    mounted(){
        this.transportType = this.dicts.transportType;
    },
    data(){
        return {
            visible: false,
            
            transportType: [],
            transport:null,
            selectes:[],
        } 
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        }
    },
    methods: {
        showDialog(selectes){
            this.selectes = selectes;
            this.transport = null;
            this.visible = true;
        },
        submit(){
            if(!this.transport){
                this.$message(this.msg('请选择配送方式'));
                return;
            }
            let ids = this.selectes.map(e => e.stockId).join(",")
            this.$axios.post(this.$kit.api.stockDetail.updateTransport
                        +"?transport="+this.transport,
                        ids
            ).then((result) => {
                if(result.status){
                    this.visible = false;
                    this.$emit("finish");
                }
                this.$message(result.msg);
            });
        }
    }
}

</script>